/* eslint eqeqeq: 0 */
export default (item, items) => items.includes(item);
